import { useState } from 'react';
import ToolsOpt from '../../components/seo/ToolsOpt';
import "./FileCompress.css";
import { FaUpload, FaDownload } from "react-icons/fa";

export default function FileCompress() {
    const [input, setInput] = useState(null);
    const [compressedFile, setCompressedFile] = useState(null);
    const [compressedFilename, setCompressedFilename] = useState("");
    const [error, setError] = useState("");
    const [uploadStatus, setUploadStatus] = useState("");

    const handleChange = (e) => {
        const file = e.target.files[0];
        setError("");
        setUploadStatus("");
        setCompressedFile(null);
        setCompressedFilename("");

        if (!file) {
            setInput(null);
            return;
        }

        setInput(file);
    };


    const compressFile = async (endpoint) => {
        if (!input) {
            setError("Please select a file first.");
            return;
        }

        setError("");
        setCompressedFile(null);
        setUploadStatus("Compressing...");

        const data = new FormData();
        data.append("file", input);

        try {
            const response = await fetch(`https://api.explorelrt.com/${endpoint}`, {
                method: "POST",
                body: data
            });

            const output = await response.json();

            if (!response.ok || output.error) {
                setError(output.error || "Failed to compress file.");
                setUploadStatus("");
                return;
            }


            const fileData = output.file;

            setCompressedFile(fileData);
            setCompressedFilename(output.filename || "compressed_file");
            setUploadStatus("Compression successful!");

        } catch (err) {
            console.error("Error compressing file:", err);
            setError("Failed to connect to the server.");
            setUploadStatus("");
        }
    };


    const downloadFile = (dataUrl, filename) => {
        if (!dataUrl) return;
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const isImage = compressedFilename.endsWith('.png') ||
        compressedFilename.endsWith('.jpg') ||
        compressedFilename.endsWith('.jpeg') ||
        compressedFilename.endsWith('.heic') ||
        compressedFilename.endsWith('.heif');


    return (
        <>
            <ToolsOpt
                title="File Compress"
                description="This is your go-to app for compressing file types instantly on your device."
                keywords="File, File Compressor, JPEG, JPG, PNG, HEIC, HEIF, Compress, Compression, File Compression, File Size Reduction, Reduce File Size, Optimize Images, Image Compression, File Optimization"
            />
            <h1 style={{ margin: "10%", display: "flex", justifyContent: "center" }}> Explorelrt File Compress</h1>

            <div className='compressContainer'>
                <div className='inputContainer'>
                    <p>Upload file to compress</p>
                    <div>
                        <input
                            className='input'
                            type="file"
                            onChange={handleChange}
                        />
                        <FaUpload className='uploadIcon' />
                    </div>
                    {input && <p className="selected-file">Selected: {input.name}</p>}
                </div>


                <div className='buttonContainer'>
                    <button onClick={() => compressFile("compressto75percent")}>
                        Compress to 75% Quality
                    </button>
                    <button onClick={() => compressFile("compressto50percent")}>
                        Compress to 50% Quality
                    </button>
                    <button onClick={() => compressFile("compressto25percent")}>
                        Compress to 25% Quality
                    </button>
                </div>


                <div className='outputContainer'>
                    {error && <p className="error-text" style={{ color: 'red' }}>{error}</p>}
                    {uploadStatus && <p className="status-text">{uploadStatus}</p>}


                    {compressedFile && (
                        <div className="preview-box">

                            {isImage && (
                                <img
                                    src={compressedFile}
                                    alt="Compressed Preview"
                                    style={{ maxWidth: '320px', borderRadius: '8px' }}
                                />
                            )}

                            <br />

                            <button
                                className="download-btn"
                                onClick={() => downloadFile(compressedFile, compressedFilename)}
                            >
                                <FaDownload /> Download {compressedFilename}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
